/**
 * "A", "A and B", "A, B and C" — a readable list, not a machine one.
 *
 * Lifted out of results.tsx (VIT-18206) so the provider description joins its
 * focus tags exactly as the results description joins provider names. Two copies
 * would be two places for the Oxford comma question to be answered differently,
 * in adjacent SERP snippets for the same site.
 *
 * No Oxford comma, and no trailing punctuation: the caller owns the sentence this
 * sits inside.
 */
export const listSentence = (items: string[]): string =>
  items.length <= 1 ? (items[0] ?? '') : `${items.slice(0, -1).join(', ')} and ${items.at(-1)}`
